(function () {
  var disableInput = function(variantInputs) {
    variantInputs.forEach(variantInput => {
      variantInput.disabled = true;
    });
  }
  
  var productVariantJson = document.getElementById('productVariantJson');
  if(productVariantJson) {
    var productVariants = document.querySelectorAll('product-variants .product-variant');
    var productVariantJsonData = JSON.parse(productVariantJson.textContent);
    var currentOptions = productVariantJson.dataset.currentOptions.split('::');
    for (i = 0; i < currentOptions.length; i++) {
      for (j = 1; j < productVariants.length; j++) {
        if(i != j) {
          var currentSelected = currentOptions[i];
          var productVariantEl = productVariants[j];
          if(productVariantEl.querySelector('input')) {
            var variantInputs = productVariantEl.querySelectorAll('input');
            disableInput(variantInputs);
            productVariantJsonData.forEach(productVariant => {
              if(productVariant.options[i] == currentSelected) {
                variantInputs.forEach(variantInput => {
                  if(variantInput.value == productVariant.options[j]) variantInput.disabled = false;
                });
              }
            });
          }
        }
      }
    }
    var productVariantsEl = document.querySelector('product-variants[data-main-product-variants]');
    if ( productVariantsEl ) {
      productVariantsEl.addEventListener('VARIANT_CHANGE', function(e) {
        var variantData = e.target.variantData;
        var currentVariant = e.target.currentVariant;
        if(currentVariant) var currentOptions = currentVariant.options;
        else var currentOptions = e.target.options;
        console.log("currentVariant",currentVariant)
       
        for (i = 0; i < currentOptions.length; i++) {
          for (j = 1; j < productVariants.length; j++) {
            if(i != j) {
              var currentSelected = currentOptions[i];
              var productVariantEl = productVariants[j];
              if(productVariantEl.querySelector('input')) {
                var variantInputs = productVariantEl.querySelectorAll('input');
                disableInput(variantInputs);
                let count = 0;
                productVariantJsonData.forEach(productVariant => {
                  if(productVariant.options[i] == currentSelected) {
                    variantInputs.forEach(variantInput => {
                      if(variantInput.value == productVariant.options[j]) {
                        variantInput.disabled = false;
                        if(++count == 1 && !currentVariant) {
                          setTimeout(function() {variantInput.click();}, 1);
                        }
                      }
                    });
                  }
                });
              }
            }
          }
        }
      });
    }
  }
})();